<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid pt-3">
    <div class="row" >
      <div class="category-head" style="background-color: #ffffff">
        <div class="back-link">
          <a @click="$router.back()"> <i class="fas fa-chevron-left " style="color: #414141"></i></a>
        </div>
        <div class="category-title">
          <p class="pt-3" style="font-weight: bold;color: #414141"> {{ $t('PROFILE') }} </p>
        </div>
        <router-link class="search-friend-icon" to="/find-friends">

        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="user-profile d-flex justify-content-between">
          <div class="user-info d-flex flex-column" v-if="checkEmptyUser">
            <div class="user-content d-flex align-items-center">
              <img :src="user.image_url" class="" alt="user-name" width="55" height="55" style="border-radius: 50%;padding: 0.25rem; background-color: #fff;border: 1px solid #dee2e6;">
              <div class="user-name text-white">{{ user.name }}</div>
            </div>
            <div class="user-level-info d-flex">
<!--              <div class="label-info d-flex justify-content-center align-items-center">-->
<!--                <span class="user-label-circle">{{ convertNumberToLangWise(user.points) }}%</span>-->
<!--                লেভেল {{ convertNumberToLangWise(user.level) }}-->
<!--              </div>-->
<!--              <div class="coin-info gap-1 d-flex justify-content-center align-items-center ">-->
<!--                <img src="@/assets/img/ic_coin.png" alt="wallet-coin" width="20" height="20">-->
<!--                {{ convertNumberToLangWise(wallet.coins) }}-->
<!--              </div>-->
<!--              <div class="gold-info d-flex gap-1 justify-content-center align-items-center ">-->
<!--                <img src="@/assets/img/ic_gem.png" alt="wallet-gems" width="20" height="20">-->
<!--                {{ convertNumberToLangWise(wallet.gems) }}-->
<!--              </div>-->
            </div>
<!--            <div class="remove-bkash" v-if="removeBkashShow" @click="cancelAgreement">-->
<!--              <img src="@/assets/img/logos/bkash-icon-logo.svg" width="20" height="20" alt="bkash logo">-->
<!--              রিমুভ বিকাশ একাউন্ট-->
<!--            </div>-->
          </div>
          <router-link :to="{ path: 'edit-profile', query: {
            id: user.id,
            image: user.image_url,
            name: user.name,
            phone: user.phone,
            email: user.email,
          }}" class="user-profile-edit"><i class="fas fa-pen fa-xs" ></i></router-link>
        </div>
      </div>
    </div>
    <div class="row" v-if="false">
      <div class="col-lg-12">
        <div class="challenge">
          <div class="row">
            <div class="challenge-title">চ্যালেঞ্জ জেতার পরিসংখ্যান </div>
          </div>
          <div class="row mx-auto">
            <div class="col-sm-3 col-md-4 col-lg-4">
              <div class="challenge-card-item">
                <circle-progress :percent="win" :show-percent="true" :viewport="true" />
                <h6>বিজয় </h6>
              </div>
            </div>
            <div class="col-sm-3 col-md-4 col-lg-4">
              <div class="challenge-card-item">
                <circle-progress :percent="draw" :show-percent="true" :viewport="true"/>

                <h6>ড্র </h6>
              </div>
            </div>
            <div class="col-sm-3 col-md-4 col-lg-4">
              <div class="challenge-card-item">
                <circle-progress :percent="loss" :show-percent="true" :viewport="true"/>
                <h6>পরাজয় </h6>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="row" v-if="false">
      <div class="col-lg-12">
        <div class="bcs-section mb-2">
          <div class="row">
            <div class="col-lg-12">
              <div class="bcs-content d-flex justify-content-between align-items-center">
                <div class="bcs-title">বিসিএস টেস্ট  রেজাল্ট</div>
                <select class="form-select bcs-report" @change="onChangeBcsReport" v-model="bcsReport">
                  <option value="today">আজ</option>
                  <option value="this_week">এই সপ্তাহে</option>
                  <option value="this_month">এই মাসে</option>
                </select>
              </div>
              <hr>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="given-model-test d-flex justify-content-between align-items-center">
                <div class="given-model-test-title"> মডেল টেস্ট  দিয়েছেন </div>
                <div class="given-model-test-total">{{ bcsHistory.test_played }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="question-play d-flex justify-content-between align-items-center">
                <div class="question-play-title">প্রশ্ন খেলেছেন </div>
                <div class="question-play-total">{{ bcsHistory.question_played }}</div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-3">
              <div class="bcs-card-item">
                <circle-progress :percent="bcsHistory.mark" :show-percent="true"/>
                <h6>মার্ক </h6>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="bcs-card-item">
                <circle-progress :percent="bcsHistory.correct" :show-percent="true"/>
                <h6>সঠিক  </h6>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="bcs-card-item">
                <circle-progress :percent="bcsHistory.wrong" :show-percent="true"/>
                <h6>ভুল  </h6>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="bcs-card-item">
                <circle-progress :percent="bcsHistory.skipped" :show-percent="true"/>
                <h6>স্কিপড </h6>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import "vue3-circle-progress/dist/circle-progress.css";
import CircleProgress from "vue3-circle-progress";
import {sendRequest} from '@/http/axios.method';
import Loader from "@/views/components/Loader";
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import _ from "lodash";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "profile",
  components: {
    CircleProgress,
    Loader,
  },

  data() {
    return {
      loaderActive: false,
      showMenu: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      user: [],
      wallet: [],
      win: 0,
      draw: 0,
      loss: 0,
      bcsHistories: [],
      bcsHistory: [],
      bcsReport: 'today',
      removeBkashShow: false,
      activeAgreement: [],
    };
  },

  mounted() {
    this.$store.state.isAbsolute = true;
    setNavPills();
    setTooltip();
    this.getUser();
    this.getBcsHistory();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  },

  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },
    getUser() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/user', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.user = response.data;
              this.activeAgreement = this.user.active_agreement;
              this.removeBkashShow = ! _.isNull(this.activeAgreement.agreementID)
              this.wallet = this.user.wallet;
              this.win = this.user.win;
              this.draw = this.user.draw;
              this.loss = this.user.loss;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    cancelAgreement() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/nagorik/cancel-agreement', {agreementID: this.activeAgreement.agreementID }, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.data.success) {
              this.removeBkashShow = false;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    getBcsHistory() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/bcs-test/history', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.bcsHistories = response.data;
              this.bcsHistory = this.bcsHistories.today;

            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    onChangeBcsReport() {
      if (this.bcsReport === 'today') {
        this.bcsHistory = this.bcsHistories.today;
        return;
      }
      if (this.bcsReport === 'this_week') {
        this.bcsHistory = this.bcsHistories.this_week;
        return;
      }
      if (this.bcsReport === 'this_month') {
        this.bcsHistory = this.bcsHistories.this_month;
      }

    }
  },
  computed: {
    checkEmptyUser() {
      return ! _.isEmpty(this.user);
    }
  }
};
</script>
